(function () {
    // Function to handle the video player setup (YouTube and Vimeo)
    function onVideoPlayerReady() {
        var thumbnailWrappers = document.querySelectorAll(".thumbnail-wrapper");
        thumbnailWrappers.forEach(function (thumbnailWrapper) {
            var thumbnail = thumbnailWrapper.querySelector(".video-thumbnail");
            var platform = thumbnail.dataset.platform;
            var videoId = thumbnail.dataset.videoId;
            var videoPlayerContainer =
                thumbnailWrapper.parentNode.querySelector(
                    ".video-player-container"
                );
            var videoPlayer =
                videoPlayerContainer.querySelector(".video-player");

            if (platform === "youtube") {
                // Preload the YouTube player
                var player = new YT.Player(videoPlayer, {
                    height: "360",
                    width: "640",
                    videoId: videoId,
                    playerVars: {
                        autoplay: 0,
                        controls: 1,
                    },
                });

                // Set up event listener for clicking on the thumbnail
                thumbnailWrapper.addEventListener("click", function () {
                    thumbnailWrapper.classList.add("animate");
                    setTimeout(function () {
                        thumbnailWrapper.style.display = "none";
                        videoPlayerContainer.style.display = "block";
                        player.playVideo();
                    }, 500); // Delay the removal of thumbnail wrapper until the animation finishes
                });
            } else if (platform === "vimeo") {
                // Preload the Vimeo player
                var options = {
                    id: videoId,
                    width: 640,
                    height: 360,
                    autoplay: false,
                    controls: true,
                };
                var player = new Vimeo.Player(videoPlayer, options);

                // Set up event listener for clicking on the thumbnail
                thumbnailWrapper.addEventListener("click", function () {
                    thumbnailWrapper.classList.add("animate");
                    setTimeout(function () {
                        thumbnailWrapper.style.display = "none";
                        videoPlayerContainer.style.display = "block";
                        player.play();
                    }, 500); // Delay the removal of thumbnail wrapper until the animation finishes
                });
            }
        });
    }

    // Check if there are YouTube embeds on the page
    var youtubeEmbeds = document.querySelectorAll(
        ".thumbnail-wrapper--youtube"
    );
    if (youtubeEmbeds.length > 0) {
        // Load the YouTube player API
        var youtubeTag = document.createElement("script");
        youtubeTag.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(youtubeTag);

        // Wait for the YouTube API to be ready
        window.onYouTubeIframeAPIReady = function () {
            onVideoPlayerReady();
        };
    }

    // Check if there are Vimeo embeds on the page
    var vimeoEmbeds = document.querySelectorAll(".thumbnail-wrapper--vimeo");
    if (vimeoEmbeds.length > 0) {
        // Load the Vimeo player API
        var vimeoTag = document.createElement("script");
        vimeoTag.src = "https://player.vimeo.com/api/player.js";
        document.body.appendChild(vimeoTag);

        // Wait for the Vimeo API to be ready
        var checkVimeoApiReady = setInterval(function () {
            if (typeof Vimeo !== "undefined") {
                clearInterval(checkVimeoApiReady);
                onVideoPlayerReady();
            }
        }, 100);
    }
})();
